import { render, staticRenderFns } from "./ViewNotes.vue?vue&type=template&id=84f34078"
import script from "./ViewNotes.vue?vue&type=script&lang=js"
export * from "./ViewNotes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports